// removed by extract-text-webpack-plugin
module.exports = {"section":"_36GBkbBGtkEBXAo6yMIAAp","instructions":"_1rMDteBxC-owmIYKIuFJHU","text":"_1Py883WmnDW1a6smeNpEUW","view":"_2pI0zVSx84a0Aj4pvUfw50","image":"_2yF68FrLDGOotkNmP_i_q9","imageContainer":"_3-Njw3873z8Ja2hig4z3em"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Templates/Main/Instructions/styles.css
// module id = 2963
// module chunks = 0